import script from "./batchOrderSaleNew.vue?vue&type=script&setup=true&lang=js"
export * from "./batchOrderSaleNew.vue?vue&type=script&setup=true&lang=js"

import "./batchOrderSaleNew.vue?vue&type=style&index=0&id=47b02c71&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b02c71"]])

export default __exports__